export default __webpack_public_path__ + "static/media/facebook.879b0d6a.webp";